module.exports = __webpack_public_path__ + "static/img/thhxyw.d59c2e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thhxyw.png
// module id = 2+t/
// module chunks = 0